import { createFileRoute } from '@tanstack/react-router';
import { PersonalizacoesComandosPage } from '@/features/comando-sql/page/PersonalizacoesComandosPage';

export const Route = createFileRoute('/a/personalizacoes/comandos')({
    component: PersonalizacoesComandosPage,
});
